module.exports = __webpack_public_path__ + "static/20191116_170557-8c02892922d5c43aae408e585a1a5414.webp";